import { CommonDropdownOptions } from '@ardoq/global-consts';

export type ReferenceTypeOption =
  | TraversedReferenceTypeInfo
  | CommonDropdownOptions;
export const isTraversedReferenceType = (
  referenceType: ReferenceTypeOption
): referenceType is TraversedReferenceTypeInfo =>
  !(
    typeof referenceType === 'string' && referenceType in CommonDropdownOptions
  );
export type SelectedReferenceTypeInfo = {
  referenceWorkspaceId: string | undefined;
  referenceTypeId: string | undefined;
  linkedWorkspaceId: string;
  /**
   * Traversal direction relative to the focal component: `true` follows outgoing
   * references to their targets, `false` incoming references from their sources.
   */
  isOutgoing: boolean;
  /** Optional narrowing to a specific linked-component type name. Used by
   * CM2 (ARD-31884) to make the row/column dropdown distinguish between
   * different connected component types reachable via the same reference
   * type. Undefined ⇒ match any linked component type (backward-compatible
   * default for views that don't set it). */
  linkedComponentTypeName?: string;
};
export type TraversedReferenceTypeInfo = SelectedReferenceTypeInfo & {
  referenceTypeName: string;
  displayName: string;
};
export const matchSelectedReferenceType = (
  a: SelectedReferenceTypeInfo,
  b: SelectedReferenceTypeInfo
) =>
  a.referenceWorkspaceId === b.referenceWorkspaceId &&
  a.referenceTypeId === b.referenceTypeId &&
  a.linkedWorkspaceId === b.linkedWorkspaceId &&
  a.isOutgoing === b.isOutgoing &&
  a.linkedComponentTypeName === b.linkedComponentTypeName;
